/**
 * Simple HTTPGet client wrapped around window.fetch
 * @export
 * @class HTTPGetClient
 */

type endpoints =
  | `calculators/${string}/json/${string}.json`
  | `calculators/${string}/compiled-lang/${string}.json`
  | `forms/privacy/compiled-lang/${string}.json`
  | `forms/sustainability-scan/compiled-lang/${string}.json`
  | 'privacyform/sendprivacyform'
  | 'calculator/calculateyearlyincome'
  | 'calculator/maximummortgagebyincome'
  | 'employerstatement/aanvullendevoorzieningen'
  | 'residencevalue/calculatepropertyvalue'
  | 'employerstatement/werkgeversverklaring'
  | 'certificate/hypothekercertificate'
  | 'office/getlist'
  | 'housepricepersquaremeter'
  | `residencevalue/getaddressinformation?${string}`
  | `residencevalue/getpropertyinformation?${string}`
  | 'nhg'
  | `decision-tree/${string}/json/questions-${string}.json`
  | `bike-relay-40-years/json/${string}.json`
  | `interestrates/getmortgagetypes/${string}`
  | `interestrates/hypotheekaanbieders/${string}`
  | `questionnaire/${string}`
  | `https://raadhuys.nodum.io/api/hypotheker-api?apiKey=91da9493217153354c8e954b3ecfb5dbc21f431f${string}`;

export default class HTTPGetClient {
  config: RequestInit = {
    method: 'GET',
    credentials: 'include'
  };

  baseUrl = '/';

  constructor({ baseUrl }: { baseUrl: string }) {
    this.baseUrl = baseUrl;
  }

  get<R>(endpoint: endpoints, config: RequestInit = {}) {
    return this.request<R>(endpoint, { ...this.config, ...config });
  }

  post<R, D>(endpoint: endpoints, data: D) {
    const defaultConfig = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },

      body: JSON.stringify(data)
    };
    return this.request<R>(endpoint, defaultConfig);
  }

  private request<T>(endpoint: endpoints, config: RequestInit) {
    const url = this.baseUrl ? `${this.baseUrl}/${endpoint}` : endpoint;

    return fetch(`${url}`, config).then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        return data as T;
      } else {
        return Promise.reject(data);
      }
    });
  }
}
